/** Known prefixes for cookies. */
export const CookiePrefixes = {
  AMPLITUDE: 'AMP',
  DATADOG: '_dd',
  GOOGLE_ANALYTICS: '_ga'
} as const;
